<!-- Educational info - 教育背景-->
<template>
  <div class="info-education">
    <h1>Educational info</h1>
    <ul class="ul-item dis-80">
      <li>
        <div>Undergraduate University</div>
        <div>{{info.university}}</div>
      </li>
      <li>
        <div>Graduation Year</div>
        <div>{{info.graduationYear}}</div>
      </li>
      <li>
        <div>Department</div>
        <div>{{info.department}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-80">
      <li>
        <div>Program 01</div>
        <div>{{info.program1}}</div>
      </li>
      <li>
        <div>Overall GPA Program 01 </div>
        <div>{{info.program1OverallGPA}}</div>
      </li>
      <li>
        <div>GPA Scale</div>
        <div>{{info.gpaScale}}</div>
      </li>
      <li>
        <div>Rank Program 01</div>
        <div>{{info.program1Rank}}</div>
      </li>
      <li>
        <div>Ranking base</div>
        <div>{{info.program1RankCount}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-80">
      <li>
        <div>Program 02 (if dual major) </div>
        <div>{{info.program2}}</div>
      </li>
      <li>
        <div>Overall GPA Program 02 </div>
        <div>{{info.program2OverallGPA}}</div>
      </li>
      <li>
        <div>Rank Program 02</div>
        <div>{{info.program2Rank}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-80">
      <li>
        <div>Program (minor) </div>
        <div>{{info.minorProgram}}</div>
      </li>
      <li>
        <div>Overall GPA Program </div>
        <div>{{info.minorGPA}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-80">
      <li>
        <div>Your major GPA</div>
        <div>{{info.majorGPA}}</div>
      </li>
      <li>
        <div>Thesis Topic (If applicable)</div>
        <div>{{info.thesisTopic}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-80">
      <li>
        <div>High School</div>
        <div>{{info.highSchool}}</div>
      </li>
      <li>
        <div>Graduation Year</div>
        <div>{{info.highSchoolGraduationYear}}</div>
      </li>
      <li>
        <div>National College Entrance Exam (Gaokao) Rank</div>
        <div>{{info.gaokaoRank}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-80">
      <li>
        <div>Other related info</div>
        <div>{{info.notes}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
// api
import { infoQueryEducational } from '@/api/mentee'
export default {
  name: 'mentee-info-education',
  components: {},
  data () {
    return {
      info: {}
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {

    getInfo () {
      let param = {
        num: this.$route.params.id
      }
      infoQueryEducational(param).then(res => {
        let data = res.data.model || {}
        this.info = Object.assign({}, data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    }

  }
}
</script>
<style lang='less' scoped>
</style>
